"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useBeforeUnload(handler = (e) => { }) {
    const handlerRef = (0, react_1.useRef)(handler);
    handlerRef.current = handler;
    (0, react_1.useEffect)(() => {
        const handleBeforeunload = event => {
            let returnValue;
            if (typeof handlerRef.current === "function") {
                returnValue = handlerRef.current(event);
            }
            if (event.defaultPrevented) {
                event.returnValue = "";
            }
            if (typeof returnValue === "string") {
                event.returnValue = returnValue;
                return returnValue;
            }
        };
        window.addEventListener("beforeunload", handleBeforeunload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeunload);
        };
    }, []);
}
exports.default = useBeforeUnload;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQmVmb3JlVW5sb2FkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9ob29rcy91c2VCZWZvcmVVbmxvYWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxpQ0FBMEM7QUFFMUMsU0FBd0IsZUFBZSxDQUNyQyxVQUFVLENBQUMsQ0FBb0IsRUFBRSxFQUFFLEdBQUUsQ0FBQztJQUV0QyxNQUFNLFVBQVUsR0FBRyxJQUFBLGNBQU0sRUFBQyxPQUFPLENBQUMsQ0FBQztJQUNuQyxVQUFVLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztJQUU3QixJQUFBLGlCQUFTLEVBQUMsR0FBRyxFQUFFO1FBQ2IsTUFBTSxrQkFBa0IsR0FBRyxLQUFLLENBQUMsRUFBRTtZQUNqQyxJQUFJLFdBQVcsQ0FBQztZQUVoQixJQUFJLE9BQU8sVUFBVSxDQUFDLE9BQU8sS0FBSyxVQUFVLEVBQUU7Z0JBQzVDLFdBQVcsR0FBRyxVQUFVLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDO2FBQ3pDO1lBRUQsSUFBSSxLQUFLLENBQUMsZ0JBQWdCLEVBQUU7Z0JBQzFCLEtBQUssQ0FBQyxXQUFXLEdBQUcsRUFBRSxDQUFDO2FBQ3hCO1lBRUQsSUFBSSxPQUFPLFdBQVcsS0FBSyxRQUFRLEVBQUU7Z0JBQ25DLEtBQUssQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFDO2dCQUNoQyxPQUFPLFdBQVcsQ0FBQzthQUNwQjtRQUNILENBQUMsQ0FBQztRQUVGLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxjQUFjLEVBQUUsa0JBQWtCLENBQUMsQ0FBQztRQUU1RCxPQUFPLEdBQUcsRUFBRTtZQUNWLE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxjQUFjLEVBQUUsa0JBQWtCLENBQUMsQ0FBQztRQUNqRSxDQUFDLENBQUM7SUFDSixDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFDVCxDQUFDO0FBOUJELGtDQThCQyJ9